import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
import { API_PATH } from "../../utils/apis";

const initialState = {
  isLoading: false,
  error: false,
  search: "",
  page: 0,
  perPage: 10,
  total: 0,
  transactions: [],
  depositAccounts: [],
  overview: {},
  sortBy: null,
  filters: {
    method: "",
  },
};

const slice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getSuccess(state, action) {
      state.isLoading = false;
      state.transactions = action.payload.data;
      state.overview = action.payload.overview;
      state.depositAccounts = action.payload.depositAccounts || [];
      state.total = parseInt(action.payload.total, 10);
    },
    //  SORT & FILTER POSTS
    sortBy(state, action) {
      state.sortBy = action.payload;
    },
    filter(state, action) {
      state.filters.method = action.payload.method;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filter, sortBy } = slice.actions;

export function getWallets(
  search,
  filters,
  page,
  perpage,
  order,
  sortBy,
  isTransaction
) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(API_PATH.wallet, {
        page,
        perpage,
        order,
        sortBy,
        search,
        ...filters,
        isTransaction: isTransaction ? 1 : 0,
      });
      const { status, data, total, overview, depositAccounts } = response.data;
      if (status === "success") {
        dispatch(
          slice.actions.getSuccess({ data, total, overview, depositAccounts })
        );
      } else {
        dispatch(
          slice.actions.hasError(
            new Error(
              "We cannot fetch your transactions at the moment! Please check back later."
            )
          )
        );
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
